import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { confirm } from 'devextreme/ui/dialog';

export interface ComponentCanDeactivate {
    canDeactivate: () => boolean | Observable<boolean>;
    afterGuardRuns: () => boolean | Observable<boolean>;
}

@Injectable({
    providedIn: 'root',
})
export class PendingChangesGuard {
    async canDeactivate(component: ComponentCanDeactivate): Promise<boolean> {
        // if there are no pending changes, just allow deactivation; else confirm first
        const canDeactivate = component.canDeactivate();
        if (canDeactivate === true) {
            return true;
        } else if (canDeactivate === false) {
            const result = await confirm('Do you want to continue? Press No to go back and save, or Yes to lose these changes.', 'WARNING: You have unsaved changes');
            if (!result) {
                // user pressed No, so return false to prevent deactivation
                return false;
            } else {
                // user pressed Yes, so return true to allow deactivation
                await component.afterGuardRuns?.();
                return true;
            }
        }
        // return component.canDeactivate()
        //     ? true
        //     : // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
        //       // when navigating away from your angular app, the browser will show a generic warning message
        //       // see http://stackoverflow.com/a/42207299/7307355
        //       await confirm('Do you want to continue? Press No to go back and save, or Yes to lose these changes.', 'WARNING: You have unsaved changes');
    }
}
